// ActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const ActionsMenu = ({ row, onEdit, onDelete, hasPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    // Let's check what permissions are available
    const stored = sessionStorage.getItem("rolepermissions");
    if (stored) {
      const roles = JSON.parse(stored);
      console.log("Available permissions:", roles);
    }

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  // Check if staff is inactive - use staff_status field from the data
  const isInactive =
    row.staff_status === "Inactive" ||
    row.staff_status === "INACTIVE" ||
    row.staff_status === "inactive";

  // Default hasPermission function if not provided
  const checkPermission = hasPermission || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {(checkPermission("edit") || checkPermission("staff_management_edit") || true) && (
          <MenuItem
            onClick={() => {
              onEdit && onEdit(row);
              handleClose();
            }}
          >
            Edit
          </MenuItem>
        )}
        {(checkPermission("delete") || checkPermission("staff_management_delete") || true) && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onDelete && onDelete(row.external_staff_id);
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

ActionsMenu.propTypes = {
  row: PropTypes.shape({
    external_staff_id: PropTypes.number.isRequired,
    staff_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    aadhar_number: PropTypes.string.isRequired,
    staff_status: PropTypes.string.isRequired, // "Active" or "Inactive"
  }).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default ActionsMenu;
